import "./sales-landing.css";
import { useEffect } from "react";

const DEMO_VIDEO_ID = "-Tl2sM_ZvSU";
const COURSE_VIDEO_ID = "d1Ba-Q5nLdw";

export default function ThankYouPage() {
  useEffect(() => {
    document.title = "Demo umówione — Viral Partners";
    document.documentElement.classList.add("allow-scroll", "dark");
    return () => {
      document.documentElement.classList.remove("allow-scroll");
    };
  }, []);

  return (
    <div className="sales-landing">
      <section className="hero in-view" style={{ paddingBottom: 32 }}>
        <div className="container">
          <div style={{ maxWidth: 880, margin: "0 auto", textAlign: "center" }}>
            <div
              style={{
                width: 84,
                height: 84,
                borderRadius: "50%",
                background: "rgba(0,200,83,0.15)",
                color: "#00c853",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 44,
                fontWeight: 900,
                marginBottom: 24,
                border: "2px solid rgba(0,200,83,0.4)",
              }}
            >
              ✓
            </div>
            <span className="label">Demo umówione</span>
            <h1>
              Dzięki — <span className="hl">do zobaczenia na demo</span>.
            </h1>
            <p className="hero-sub" style={{ maxWidth: 720, margin: "20px auto 0" }}>
              Dostałeś maila z linkiem do rozmowy i wpisem do kalendarza. Sprawdź skrzynkę (i SPAM,
              gdyby tam wpadło).
              <br />
              <strong style={{ color: "#fff" }}>
                Zanim się spotkamy — mamy dwa prezenty, żebyś przyszedł przygotowany.
              </strong>
            </p>
            <div className="hero-cta-meta" style={{ justifyContent: "center", marginTop: 18 }}>
              <span>Google Meet · 30 min</span>
              <span>Po polsku</span>
              <span>Live na Twoim koncie</span>
            </div>
          </div>
        </div>
      </section>

      <section className="ad-creatives in-view" style={{ paddingTop: 40 }}>
        <div className="container">
          <div className="feature-row">
            <div className="feature-row-left">
              <div className="feature-row-num">#1</div>
              <span className="label">Materiał przed demo</span>
              <h2>
                Zobacz <span className="hl">jak generujemy reklamy graficzne z AI</span> które
                dowożą leady.
              </h2>
              <p>
                Konkretny tutorial: jak w Viral Partners tworzymy grafiki reklamowe AI, które
                realnie konwertują na kwalifikowane leady. Pokazane na żywym koncie, z briefem,
                prompt'em i wynikami. 0 teorii — same kliknięcia i decyzje.
              </p>
              <ul className="feature-row-bullets">
                <li>Pełny flow: brief → grafika AI → publikacja → lead w CRM</li>
                <li>Co wpisać w briefie żeby AI nie wyplulo "stockowego AI slopa"</li>
                <li>Format pod feed, square i story — eksport jednym klikiem</li>
                <li>Przyjdziesz na demo z gotowymi pytaniami, nie z "co to w ogóle robi"</li>
              </ul>
            </div>
            <div className="feature-row-right">
              <div
                style={{
                  width: "100%",
                  aspectRatio: "16 / 9",
                  borderRadius: 14,
                  overflow: "hidden",
                  border: "1px solid rgba(255,255,255,0.08)",
                  background: "#000",
                  boxShadow: "0 30px 80px -30px rgba(0,0,0,0.7)",
                }}
              >
                <iframe
                  src={`https://www.youtube.com/embed/${DEMO_VIDEO_ID}?rel=0&modestbranding=1`}
                  title="Viral Partners — przykład działania aplikacji"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                  style={{ width: "100%", height: "100%", border: 0, display: "block" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="ad-creatives in-view"
        style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}
      >
        <div className="container">
          <div className="feature-row feature-row-reverse">
            <div className="feature-row-right">
              <div
                style={{
                  width: "100%",
                  aspectRatio: "16 / 9",
                  borderRadius: 14,
                  overflow: "hidden",
                  border: "2px solid rgba(230,49,38,0.4)",
                  background: "#000",
                  boxShadow: "0 30px 80px -30px rgba(230,49,38,0.4)",
                }}
              >
                <iframe
                  src={`https://www.youtube.com/embed/${COURSE_VIDEO_ID}?rel=0&modestbranding=1`}
                  title="11h darmowy kurs — marketing usług premium online"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                  style={{ width: "100%", height: "100%", border: 0, display: "block" }}
                />
              </div>
            </div>
            <div className="feature-row-left">
              <div
                className="feature-row-num"
                style={{
                  fontSize: 44,
                  background: "linear-gradient(135deg, #E63126, #FF4438)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                🎁 BONUS
              </div>
              <span className="label">Prezent za umówienie demo</span>
              <h2>
                <span className="hl">11-godzinny kurs</span> o marketingu usług premium online.
              </h2>
              <p>
                Wartość rynkowa <strong style={{ color: "#fff" }}>~2&nbsp;500 zł</strong>. Dla
                Ciebie 0 zł — w ramach podziękowania za umówienie demo. Konkret: jak pozycjonować,
                wyceniać i sprzedawać usługi premium online, z przykładami i case studies.
              </p>
              <ul className="feature-row-bullets">
                <li>
                  11 godzin treści — zero gadania, same konkrety i framework do wdrożenia od jutra
                </li>
                <li>Pozycjonowanie premium, oferta i pricing, sprzedaż 1:1 vs 1:wielu</li>
                <li>Lejki sprzedażowe, ad creative dla usług premium, copy które konwertuje</li>
                <li>Skalowanie poza dochód godzinowy — produktyzacja usługi</li>
              </ul>
              <a
                href={`https://www.youtube.com/watch?v=${COURSE_VIDEO_ID}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-xl"
                style={{ marginTop: 8 }}
              >
                Otwórz kurs na YouTube →
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="final-cta in-view">
        <div className="container">
          <span className="label">Co dalej</span>
          <h2>
            Widzimy się na <span className="hl">rozmowie</span>.
          </h2>
          <p>
            Obejrzyj powyższe materiały i przyjdź przygotowany — demo będzie szybsze i bardziej
            konkretne.
          </p>
          <div className="ctas">
            <a href="/lp" className="btn btn-secondary btn-xl">
              Wróć na stronę
            </a>
          </div>
          <div className="meta">Google Meet · 30 min · Po polsku</div>
        </div>
      </section>

      <footer className="sl-footer">
        <div className="container">
          <div className="copy">© 2026 Viral Partners · VP Holding PSA</div>
          <div className="links">
            <a href="https://viral.partners/regulamin">Regulamin</a>
            <a href="https://viral.partners/polityka-prywatnosci">Polityka prywatności</a>
            <a href="mailto:maciej@viral.partners">Kontakt</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
